import { createAsyncThunk } from '@reduxjs/toolkit';

import BorrowerApi from 'api/BorrowerApi';

export const getBorrowerByTokenThunk = (borrowerApi: BorrowerApi) =>
  createAsyncThunk('borrower/getBorrowerByToken', async () => {
    return await borrowerApi.getBorrowerByToken();
  });
